import { createModel } from '../model/index.js';
import model from './SearchRequest.model.js';
const SearchRequestModel = createModel(model);
export default class SearchRequest extends SearchRequestModel {
    getWidgetInfo(widgetId) {
        return this.getWidgetItems()?.find((widget) => widget.rfk_id && widget.rfk_id === widgetId);
    }
    addWidgets(items) {
        items.forEach((item) => this.addWidgetItem(item));
        return this;
    }
}
